import React from "react";
import "./Doors.scss";
import raamLinks from "../../../assets/img/raam_L.png";
import raamRechts from "../../../assets/img/raam_R.png";
import { useGameState } from "../../../hooks/useGameState";

interface IProps {
    state: 'open' | 'closed'
    visible: boolean
}

export function Doors({ state, visible }: IProps) {
    const { setGameState, level } = useGameState();
    return (
        <div className={`doors-wrapper ${visible ? 'visible' : ''} ${state}`} onClick={() => setGameState('playing')}>
            <div className="left-side" style={{backgroundImage: `url(${raamLinks})`}} />
            <div className="right-side" style={{backgroundImage: `url(${raamRechts})`}} />
            <svg xmlns="http://www.w3.org/2000/svg" width="372" height="372" viewBox="0 0 372 372">
                <g id="leve_indicator" transform="translate(-357 -764)">
                    <circle id="Ellipse_7" data-name="Ellipse 7" cx="186" cy="186" r="186" transform="translate(357 764)" fill="#007cb4"/>
                    <g id="Ellipse_8" data-name="Ellipse 8" transform="translate(377 784)" fill="#123646" stroke="#58fbff" strokeWidth="1">
                        <circle cx="166" cy="166" r="166" stroke="none"/>
                        <circle cx="166" cy="166" r="165.5" fill="none"/>
                    </g>
                    <text id="Level_1" data-name="Level 1" transform="translate(545 911)" fill="#fff27b" fontSize="70" fontFamily="Teko-SemiBold, Teko" fontWeight="600" letterSpacing="0.05em"><tspan x="-97.895" y="0">LEVEL {level}</tspan></text>
                    <text id="Klaar_om_te_starten_" data-name="Klaar om
te starten?" transform="translate(544 981)" fill="#fff" fontSize="47" fontFamily="QuietSans-Bold, Quiet Sans" fontWeight="700" letterSpacing="0.05em"><tspan x="-94.822" y="0">Klaar om</tspan><tspan x="-116.137" y="37">te starten?</tspan></text>
                </g>
            </svg>
        </div>
    )
}
